module.exports = __webpack_public_path__ + "img/align_vertical.1af4bd49.svg";